import { cloneDeep } from "lodash";
import { DEFAULT_TABLE_PAGE_SIZE } from "../../utilities/constants";

export const SET_DEAL_PLAN_SUMMARY_API_REFRESH = 'SET_DEAL_PLAN_SUMMARY_API_REFRESH';
export const SET_DEAL_PLAN_SUMMARY_DATA = 'SET_DEAL_PLAN_SUMMARY_DATA';
export const SET_DEAL_PLAN_SUMMARY_DATA_CLONE ='SET_DEAL_PLAN_SUMMARY_DATA_CLONE';
export const SET_DEAL_SUMMARY_DATA_TABLE_CURRENT_PAGE = 'SET_DEAL_SUMMARY_DATA_TABLE_CURRENT_PAGE';
export const SET_DEAL_SUMMARY_DATA_TABLE_PAGE_SIZE = 'SET_DEAL_SUMMARY_DATA_TABLE_PAGE_SIZE';
export const SET_DEAL_SUMMARY_DATA_TOTAL_RECORD_COUNT ='SET_DEAL_SUMMARY_DATA_TOTAL_RECORD_COUNT';
export const SET_DEAL_SUMMARY_DATA_TABLE_DEFAULT_FILTERS ='SET_DEAL_SUMMARY_DATA_TABLE_DEFAULT_FILTERS'
export const SET_DEAL_SUMMARY_DROPDOWN_SELECTED_FILTERS ='SET_DEAL_SUMMARY_DROPDOWN_SELECTED_FILTERS'
export const SET_DEAL_SUMMARY_TABLE_DATA_LOADING = 'SET_DEAL_SUMMARY_TABLE_DATA_LOADING';

export const setDealPlanSummaryDefaultFilters = (filters = {}) => ({
    type:SET_DEAL_SUMMARY_DATA_TABLE_DEFAULT_FILTERS,
    payload:cloneDeep(filters)
})

export const setDealPlanSummaryDropdownAppliedFilters = (filters = {}) => ({
    type:SET_DEAL_SUMMARY_DROPDOWN_SELECTED_FILTERS,
    payload:cloneDeep(filters)
})

export const setDealPlanSummaryApiTrigger = (isRefreshedData = false) => ({
    type:SET_DEAL_PLAN_SUMMARY_API_REFRESH, payload:isRefreshedData
})

export const setDealPlanSummaryData = (data = [], isDataLoading = false) => ({
    type:SET_DEAL_PLAN_SUMMARY_DATA,
    payload:{data:cloneDeep(data), isLoading:isDataLoading}
})

export const setDealPlanSummaryDataClone = (data = [], isDataLoading = false) => ({
    type:SET_DEAL_PLAN_SUMMARY_DATA_CLONE,
    payload:{displayData:cloneDeep(data), isLoading:isDataLoading}
})

export const setDealPlanSummaryDataTableCurrentPage = (currentPage = 1) => ({
    type: SET_DEAL_SUMMARY_DATA_TABLE_CURRENT_PAGE,
    payload:currentPage
})

export const setDealPlanSummaryDataTablePageSize = (pageSize= DEFAULT_TABLE_PAGE_SIZE) => ({
    type: SET_DEAL_SUMMARY_DATA_TABLE_PAGE_SIZE,
    payload:pageSize
})

export const setDealPlanSummaryDataTotalRecordCount = (totalRecordCount = 0) => ({
    type:SET_DEAL_SUMMARY_DATA_TOTAL_RECORD_COUNT,
    payload:totalRecordCount
})

export const setDealsSummaryTableDataLoading = (bool) => ({
    type:SET_DEAL_SUMMARY_TABLE_DATA_LOADING,
    payload:bool
})